import { assessCall } from '../core/assess';
import { toSummaryView } from '../shared/summary-view';
import { DemoApiError } from './api';
import { runLiveDemo } from './live';
import { SAMPLE_EXTRACTION, SAMPLE_HISTORY, SAMPLE_TRANSCRIPT } from './sample';
import { getTurnstileToken } from './turnstile';
import { DemoView } from './view';

const FALLBACK_NOTICE: Partial<Record<DemoApiError['code'], string>> = {
  geo_blocked: 'Голосовое демо недоступно в вашей стране. Вот пример разговора.',
  ip_limit: 'Вы уже попробовали демо сегодня. Вот пример разговора.',
  day_limit: 'Лимит демо на сегодня исчерпан. Вот пример разговора.',
};
const GENERIC_NOTICE = 'Не получилось начать разговор. Вот пример, как это работает.';

const sleep = (ms: number) => new Promise<void>((resolve) => setTimeout(resolve, ms));

async function playSample(view: DemoView, fast: boolean): Promise<void> {
  view.startConversation('Пример разговора');
  const started = Date.now();
  for (const turn of SAMPLE_TRANSCRIPT) {
    view.addTurn(turn.speaker, turn.text);
    view.setTimer(Math.floor((Date.now() - started) / 1000));
    if (!fast) await sleep(900 + turn.text.length * 25);
  }
  view.setStatus('Разговор завершён', false);
  const assessment = assessCall(SAMPLE_EXTRACTION, SAMPLE_TRANSCRIPT, SAMPLE_HISTORY);
  view.showSummary(toSummaryView(assessment), 'Сводка для вас · пример');
}

async function startLive(view: DemoView, siteKey: string, fast: boolean): Promise<void> {
  try {
    const token = await getTurnstileToken(view.turnstileSlot, siteKey);
    await runLiveDemo(view, token);
  } catch (error) {
    console.error(error);
    const code = error instanceof DemoApiError ? error.code : null;
    view.showNotice((code && FALLBACK_NOTICE[code]) ?? GENERIC_NOTICE);
    await playSample(view, fast);
  }
}

function main(): void {
  const view = new DemoView();
  const fast = new URLSearchParams(location.search).has('fast');
  const siteKey = document.body.dataset.turnstileSiteKey ?? '';
  const liveEnabled = siteKey !== '' && !siteKey.startsWith('%');

  const run = (task: () => Promise<void>) => {
    view.setBusy(true);
    view.showNotice(null);
    void task().finally(() => {
      view.setBusy(false);
    });
  };

  view.liveButton.hidden = !liveEnabled;
  view.liveButton.addEventListener('click', () => {
    run(() => startLive(view, siteKey, fast));
  });
  view.sampleButton.addEventListener('click', () => {
    run(() => playSample(view, fast));
  });
  if (fast) run(() => playSample(view, true));
}

main();
